import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedComics from '@/pages/home/components/FeaturedComics';
import HotUpdatesSection from '@/pages/home/components/HotUpdatesSection';
import FAQSection from '@/pages/home/components/FAQSection';
import NewsletterCTA from '@/pages/home/components/NewsletterCTA';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedComics />
        <HotUpdatesSection />
        <FAQSection />
        <NewsletterCTA />
      </main>

      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '桃桃漫画网',
            url: 'https://taotao-comic.com/',
            description: '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@taotao-comic.com',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩国漫画无删减漫画下拉式-免费韩漫在线阅读-桃桃漫画网',
            description: '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。',
            url: 'https://taotao-comic.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '桃桃漫画网',
              url: 'https://taotao-comic.com/',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
    </>
  );
}